import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';

export default function NotFound() {
  return <section className="not-found"><Seo title="Page Not Found" noIndex /><span>404</span><h1>This road does not go anywhere.</h1><p>The page may have moved during the website rebuild.</p><Link className="button button--primary" to="/"><ArrowLeft size={18} /> Return home</Link></section>;
}
